import limitValue from "../../../../utils/limit-value";
import WINDOW from "../../../../utils/window";
import getAxisValue from "./get-axis-value";
import getCenter from "./get-center";
import getMaxSide from "./get-max-side";
import getPointerSelfPercentsX from "./get-pointer-self-percents-x";
import getPointerSelfPercentsY from "./get-pointer-self-percents-y";

/**
 *
 * @param {MainClassProps} main
 * @param {TriggerProps} trigger
 * @returns
 */
const getPointerSelf = (main, trigger) => {
  let type = 0;

  const axis = getAxisValue(trigger);

  const pThreshold = /** @type {TriggerParameterTypeProps} */ (
    trigger.get("p_threshold")
  );

  const threshold = /** @type {Number} */ (pThreshold.get("value"));

  const pMethod = /** @type {TriggerParameterTypeProps} */ (
    trigger.get("p_method")
  );

  if (pMethod.get("value") === "self_-_continuous") {
    type = 1;
  }
  if (pMethod.get("value") === "self_-_parallax") {
    type = 2;
  }

  const bounds = /** @type {BoundsProps} */ (main.bounds);
  const pointer = /** @type {Map<"x" | "y", Number>} */ (WINDOW.get("pointer"));
  const pointerX = /** @type {Number} */ (pointer.get("x"));
  const pointerY = /** @type {Number} */ (pointer.get("y"));

  const center = getCenter(bounds);
  const centerX = /** @type {Number} */ (center.get("x"));
  const centerY = /** @type {Number} */ (center.get("y"));

  const max = getMaxSide(bounds);
  const maxX = /** @type {Number} */ (max.get("x-side"));
  const maxY = /** @type {Number} */ (max.get("y-side"));

  bounds.set("max-x-side", maxX);
  bounds.set("max-y-side", maxY);

  switch (axis) {
    case "x": {
      const diffX = pointerX - centerX;
      const x = getPointerSelfPercentsX(
        diffX,
        bounds,
        pointerX,
        threshold,
        type
      );
      return type ? x : limitValue(x);
    }

    case "y": {
      const diffY = pointerY - centerY;
      const y = getPointerSelfPercentsY(
        diffY,
        bounds,
        pointerY,
        threshold,
        type
      );
      return type ? y : limitValue(y);
    }

    default: {
      const diffX = pointerX - centerX;
      const diffY = pointerY - centerY;

      const x = getPointerSelfPercentsX(
        diffX,
        bounds,
        pointerX,
        threshold,
        type
      );
      const y = getPointerSelfPercentsY(
        diffY,
        bounds,
        pointerY,
        threshold,
        type
      );
      const both = (x + y) / 2;

      return type ? both : limitValue(both);
    }
  }
};

export default getPointerSelf;
